// Catalogo pulizie GSI Italia — dato STATICO di riferimento.
//
// La tabella `cleaning_equipment_catalog` (seed migration 20260528020000) NON è
// sincronizzata come master al client, quindi i 38 item standard sono replicati
// qui per alimentare i chip "Aggiungi voce" nei cassetti di pulizia (Fase 1
// OTA-only, vedi docs/superpowers/specs/2026-05-31-cleaning-cassetti-design.md).
// Tenere allineato alla seed se cambia.

/** Sottoinsieme di frequenze usato dai cassetti (la `CleaningFrequency` piena
 *  in cleaning.ts ha anche trimestrale/semestrale/annuale/a_chiamata). */
export type CassettoFrequency = 'giornaliera' | 'settimanale' | 'mensile';

export interface CleaningCatalogItem {
  /** = cleaning_equipment_catalog.id (slug) lato DB */
  slug: string;
  /** nome mostrato e salvato su cleaning_equipments.name */
  label: string;
  frequency: CassettoFrequency;
  /** cottura|refrigerazione|lavaggio|preparazione|bar|altro */
  category: string;
}

export const CLEANING_CATALOG: CleaningCatalogItem[] = [
  // ── Giornaliere (29) ──
  { slug: 'piani_lavoro_acciaio', label: 'Piani lavoro acciaio', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'cucina_6_fuochi', label: 'Cucina 6 fuochi (piani cottura)', frequency: 'giornaliera', category: 'cottura' },
  { slug: 'bollitore', label: 'Bollitore (cuoci-pasta/uova)', frequency: 'giornaliera', category: 'cottura' },
  { slug: 'macchina_caffe', label: 'Macchina caffè', frequency: 'giornaliera', category: 'bar' },
  { slug: 'macina_caffe', label: 'Macina caffè', frequency: 'giornaliera', category: 'bar' },
  { slug: 'affettatrice', label: 'Affettatrice', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'impastatrice', label: 'Impastatrice', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'abbattitore', label: 'Abbattitore', frequency: 'giornaliera', category: 'refrigerazione' },
  { slug: 'lavelli', label: 'Lavelli', frequency: 'giornaliera', category: 'lavaggio' },
  { slug: 'forno', label: 'Forno (combinato/pizza/cucina)', frequency: 'giornaliera', category: 'cottura' },
  { slug: 'banco_lavoro_refrigerato', label: 'Banco lavoro refrigerato', frequency: 'giornaliera', category: 'refrigerazione' },
  { slug: 'piani_appoggio', label: 'Piani appoggio', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'banco_bar', label: 'Banco bar', frequency: 'giornaliera', category: 'bar' },
  { slug: 'grattugia', label: 'Grattugia', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'tritamozzarella', label: 'Tritamozzarella', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'microonde', label: 'Microonde', frequency: 'giornaliera', category: 'cottura' },
  { slug: 'planetaria', label: 'Planetaria', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'macchina_ghiaccio', label: 'Macchina ghiaccio', frequency: 'giornaliera', category: 'bar' },
  { slug: 'stufa_lievitazione', label: 'Stufa di lievitazione', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'piastra', label: 'Piastra', frequency: 'giornaliera', category: 'cottura' },
  { slug: 'bilancia', label: 'Bilancia', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'mixer', label: 'Mixer (frullatore industriale)', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'cutter', label: 'Cutter (tritatutto pro)', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'frullatore', label: 'Frullatore', frequency: 'giornaliera', category: 'bar' },
  { slug: 'lavatazzine', label: 'Lavatazzine', frequency: 'giornaliera', category: 'bar' },
  { slug: 'spremiagrumi', label: 'Spremiagrumi', frequency: 'giornaliera', category: 'bar' },
  { slug: 'banchi_esposizione', label: 'Banchi esposizione', frequency: 'giornaliera', category: 'altro' },
  { slug: 'panadora', label: 'Panadora (macchina pane)', frequency: 'giornaliera', category: 'preparazione' },
  { slug: 'tritaghiaccio', label: 'Tritaghiaccio', frequency: 'giornaliera', category: 'bar' },
  // ── Settimanali (7) ──
  { slug: 'cappa_aspirante', label: 'Cappa aspirante', frequency: 'settimanale', category: 'cottura' },
  { slug: 'cella_frigo', label: 'Cella frigo', frequency: 'settimanale', category: 'refrigerazione' },
  { slug: 'friggitrice', label: 'Friggitrice', frequency: 'settimanale', category: 'cottura' },
  { slug: 'frigoriferi', label: 'Frigoriferi', frequency: 'settimanale', category: 'refrigerazione' },
  { slug: 'scaffalature', label: 'Scaffalature', frequency: 'settimanale', category: 'altro' },
  { slug: 'vetrine_verticali', label: 'Vetrine verticali', frequency: 'settimanale', category: 'bar' },
  { slug: 'lavastoviglie', label: 'Lavastoviglie', frequency: 'settimanale', category: 'lavaggio' },
  // ── Mensili (2) ──
  { slug: 'congelatori', label: 'Congelatori', frequency: 'mensile', category: 'refrigerazione' },
  { slug: 'magazzino', label: 'Magazzino', frequency: 'mensile', category: 'altro' },
];

export function catalogByFrequency(freq: CassettoFrequency): CleaningCatalogItem[] {
  return CLEANING_CATALOG.filter((c) => c.frequency === freq);
}
